import { downgradeInjectable } from '@angular/upgrade/static';
import { AutoApplyCouponService } from '@app/service/shopping/coupon/auto-apply-coupon.service';
import { IrisClient } from '@app/service/iris/iris-client';
import { IrisService } from '@app/service/iris/iris.service';
import { IrisStrategyService } from '@app/service/iris/iris-strategy.service';
import { IrisMetricsReporter } from '@app/service/iris/iris-metrics-reporter';
import CartRewardTrackerService from '@app/components/cart-reward-tracker/cart-reward-tracker.service';
import { GrowlerService } from '@app/components/core/growler/service/growler.service';
import App from '@app/app';
import { MasterEventConsolidationService } from '@app/service/event/master-event-consolidation.service';
import { AddToCartGrowlerService } from '@app/service/add-to-cart-growler/add-to-cart-growler.service';
import { CopyOrderGrowlerService } from '@app/service/copy-order-growler/copy-order-growler.service';
import { CartChangeGrowlerService } from '@app/service/cart-change-growler/cart-change-growler.service';
import { PersonalizationGrowlerService } from '@app/service/personalization-growler/personalization-growler.service';
import { CouponCodeService } from '@app/service/shopping/coupon/coupon-code.service';
import { PackageDetailsResolver } from '@app/service/packages/package-details.resolver';

App.factory('AutoApplyCouponService', downgradeInjectable(AutoApplyCouponService));
App.factory('CartRewardTrackerService', downgradeInjectable(CartRewardTrackerService));
App.factory('IrisClient', downgradeInjectable(IrisClient));
App.factory('IrisService', downgradeInjectable(IrisService));
App.factory('IrisStrategyService', downgradeInjectable(IrisStrategyService));
App.factory('IrisMetricsReporter', downgradeInjectable(IrisMetricsReporter));
App.factory('GrowlerService', downgradeInjectable(GrowlerService));
App.factory('MasterEventConsolidationService', downgradeInjectable(MasterEventConsolidationService));
App.factory('AddToCartGrowlerService', downgradeInjectable(AddToCartGrowlerService));
App.factory('CopyOrderGrowlerService', downgradeInjectable(CopyOrderGrowlerService));
App.factory('CartChangeGrowlerService', downgradeInjectable(CartChangeGrowlerService));
App.factory('PersonalizationGrowlerService', downgradeInjectable(PersonalizationGrowlerService));
App.factory('CouponCodeService', downgradeInjectable(CouponCodeService));
App.factory('PackageDetailsResolver', downgradeInjectable(PackageDetailsResolver));
